import { EntriesTable } from "../../../../../../layout/entries/EntriesTable";
import {
    convertToJS,
    isDivisionTeamType,
} from "../../../../../../eventDivisions/helpers";
import { EntriesListHeading } from "../../../../../../layout/entries/headings/EntriesListHeading";
import { useEntriesState } from "../../../../../../layout/entries/headings/useEntriesState";
import { Icon } from "../../../../../../../styleguide/icons/Icon";
import { EmptyState } from "../../../../../../layout/EmptyState";
import { useEventDivision } from "../EventDivisionProvider";
import { FailedPayments } from "../../../../../../layout/user/FailedPayments";
import { useState } from "react";

export const EntriesList = ({ eventDivision, isGroup, manageEntries }) => {
    const parentEventDivision = convertToJS(useEventDivision());
    const hideSeeds = parentEventDivision.formatDefinition?.hideSeeds;
    const { hasBibs, confirmed, registered, alternates } = useEntriesState(
        eventDivision.entries,
        hideSeeds,
    );
    const showBibs = hasBibs || parentEventDivision.formatDefinition?.hasBibs;
    const isTeams = isDivisionTeamType(parentEventDivision);
    const teamRoles =
        parentEventDivision.template && parentEventDivision.template.teamRoles;
    const [failedPayments, setFailedPayments] = useState([]);

    const updateFailedPayments = (entries) => setFailedPayments(entries);

    const clearFailedPayments = () => setFailedPayments([]);

    return (
        <>
            <FailedPayments
                failedPayments={failedPayments}
                clearFailedPayments={clearFailedPayments}
            />

            <EntriesListHeading
                eventDivision={eventDivision}
                confirmed={confirmed}
                registered={registered}
                alternates={alternates}
                isGroup={isGroup}
                isTeams={isTeams}
                manageEntries={manageEntries}
            />

            {!!registered.length ? (
                <EntriesTable
                    confirmed={confirmed}
                    entries={registered}
                    showBibs={showBibs}
                    showSeeds={!hideSeeds}
                    seedIsPosition={
                        !!parentEventDivision.formatDefinition
                            ?.entriesRandomized
                    }
                    isTeams={isTeams}
                    teamRoles={teamRoles}
                    manageEntries={manageEntries}
                    updateFailedPayments={updateFailedPayments}
                    clearFailedPayments={clearFailedPayments}
                />
            ) : (
                <EmptyState
                    icon={<Icon icon="AthleteProfile" />}
                    text={
                        !manageEntries
                            ? "no_competitors_in_seedlist"
                            : isTeams
                              ? "no_teams_in_seedlist"
                              : "no_athletes_in_seedlist"
                    }
                />
            )}

            {!!alternates.length && (
                <EntriesTable
                    entries={alternates}
                    showBibs={showBibs}
                    isTeams={isTeams}
                    manageEntries={manageEntries}
                    statusTitle="Action"
                    isAlternates
                />
            )}
        </>
    );
};
